import React from "react";
import Icon1 from "../../assets/images/USPIcons/check-mark.png";
import USPSection2Cards from "../../components/USPSection2/USPSection2Cards";
import { Row, Col } from "react-bootstrap";
import BetterRoI from "../../assets/images/benefits/better-rate-of-return.svg";
import PreservativeFree from "../../assets/images/USPIcons/no-preservatives.png";
import ProductProvenance from "../../assets/images/benefits/provenance.svg";
import RemoteMonitoring from "../../assets/images/benefits/remote-monitoring.svg";



const BrandsBenefits = () => {
  const benefits = [
    {
      title: "Better RoI",
      bodycopy:
        "Better return on investment (RoI) serves as a significant benefit for AgriProcessingHub customers, enhancing their profitability and sustainability.        ",
      image: BetterRoI,
    },
    {
      title: "Ensured Quality",
      bodycopy:
        "Ensured quality in production ensures AgriProcessingHub customers receive high-quality products, enhancing their competitiveness and marketability.",
      image: Icon1,
    },

    {
      title: "Chemical Preservative Free Products",
      bodycopy:
        "Offering chemical preservative-free products provides a valuable benefit for AgriProcessingHub customers, meeting the increasing consumer demand for healthier and more natural food options while also potentially expanding market opportunities. ",
      image: PreservativeFree,
    },
    {
      title: "Product Provenance",
      bodycopy:
        "AgriProcessingHub offers Product Provenance, enabling brands to trace the origin and journey of their products. This transparency enhances brand trust and consumer confidence. ",
      image: ProductProvenance,
    },
    {
      title: "Remote PO Monitoring",
      bodycopy:
        "Remote PO Monitoring allows brands to efficiently track purchase orders from anywhere, ensuring timely updates and greater control over the supply chain. ",
      image: RemoteMonitoring,
    },
  ];
  return (
    <>
      {" "}
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col md={4} key={index}>
              <USPSection2Cards
                cardtitle={e.title}
                src={e.image}
                cardBodycopy={e.bodycopy}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default BrandsBenefits;
